import { getShinkaiRegistryAddress } from '../contracts';

export const getSmartContractUrl = () => {
  const registryAddress = getShinkaiRegistryAddress();
  return `https://sepolia.basescan.org/address/${registryAddress}`;
};
